import React from 'react';
import { NavLink, Redirect, Route } from 'react-router-dom';
import { BankSettings, BusinessSettings, ProfileSettings, ChangePassword } from '../..';

import './style.css';
const Index = () => {
    return (
        <div className="settings">
            <div className="settings_head">
                <h2>SETTING</h2>
            </div>
            <nav className="settings_navigation">
                <NavLink className="settings_navigation_item" activeClassName="active" to="/main/settings/profile">
                    Profile
                </NavLink>
                <NavLink className="settings_navigation_item" activeClassName="active" to="/main/settings/business">
                    Business
                </NavLink>
                <NavLink className="settings_navigation_item" activeClassName="active" to="/main/settings/bank">
                    Bank
                </NavLink>
                <NavLink
                    className="settings_navigation_item"
                    activeClassName="active"
                    to="/main/settings/changePassword"
                >
                    Change Password
                </NavLink>
            </nav>
            <div className="settings_content">
                <Route path="/main/settings/profile" exact>
                    <ProfileSettings />
                </Route>
                <Route path="/main/settings/business" exact>
                    <BusinessSettings />
                </Route>
                <Route path="/main/settings/bank" exact>
                    <BankSettings />
                </Route>
                <Route path="/main/settings/changePassword" exact>
                    <ChangePassword />
                </Route>
                <Redirect to="/main/settings/profile" />
            </div>
        </div>
    );
};

export default Index;
